import { gql } from "@apollo/client";

export const InstalledBaseNodeAttributeList = gql`
    query InstalledBaseNodeAttributeList (
        $pagination: Pagination,
        $search: SearchInput
    ) {
        installedBaseNodePropertyDefinitionList (search: $search) {
            total
            installedBaseNodePropertyDefinitions (pagination: $pagination) {
                id
                alias
                preferredName
                shortName
                dataType
                inputType
            }
        }
    }
`;



